import Mousetrap from 'mousetrap'

export default {
  mounted() {
    Mousetrap.bind('shift+n', e => {
      e.preventDefault()
      this.createHolidays()
    })

    this.$once('hook:beforeDestroy', () => {
      Mousetrap.unbind('shift+n')
    })
  },
}
